import { toAddressType } from '../../address/addresses.interface';
import { withErrorParsing } from '../../dialect-cloud-api/data-service-errors';
export class DataServiceDappAddresses {
    constructor(dataServiceDappsApi) {
        this.dataServiceDappsApi = dataServiceDappsApi;
    }
    async findAll() {
        const dappAddressesDtos = await withErrorParsing(this.dataServiceDappsApi.findAllDappAddresses());
        return dappAddressesDtos.map((it) => toDappAddress(it));
    }
}
export function toDappAddress(dto) {
    const dapp = {
        id: dto.id,
        enabled: dto.enabled,
        channelId: dto.channelId,
        address: {
            id: dto.address.id,
            type: toAddressType(dto.address.type),
            value: dto.address.value,
            verified: dto.address.verified,
            wallet: {
                address: dto.address.wallet.publicKey,
            },
        },
    };
    return dapp;
}
//# sourceMappingURL=data-service-dapp-addresses.js.map